import { RouteMatch } from "react-router-dom";

export interface CrumbParent {
  readonly label: string;
  readonly pathname: string | ((params: Readonly<Record<string, string | undefined>>) => string);
}

export const withCrumbParents = <H extends object>(handle: H, parents: readonly CrumbParent[]) => ({ ...handle, parents, phoneBack: true });

export function createCrumbHandle(label: string, key?: string) {
  const resolvedKey = key || `breadcrumbs.${label}`;
  return {
    crumb: (match: RouteMatch) => ({
      ...match,
      label,
      labelKey: resolvedKey,
      labelFallback: label,
    }),
  };
}